<template>
  <div v-loading="loading" class="cart-list">
    <h2>产品列表</h2>
    <div class="product-list">
      <div v-for="product in products" :key="product.materialID" class="product-item">
        <div class="product-image">
          <i class="el-icon-picture-outline" style="font-size: 80px; color: #ddd;"/>

          <!-- <img :src="product.image" alt="产品封面图"> -->
        </div>
        <div class="product-info">
          <h3 class="product-name" :title="product.materialName">{{product.materialName}}</h3>
          <!-- <div class="product-price">
            <span>价格:</span>
            <span class="price-value">{{product.price === 0 ? '---' : product.price}}</span>
          </div> -->
          <el-button type="primary" :loading="product.loading" @click="addToCart(product)">加入购物车</el-button>
        </div>
      </div>
    </div>

    <product-add-to-cart ref="productAddToCart"/>
  </div>
</template>

<script>
  import ProductAddToCart from "./ProductAddToCart.vue";
  
  export default {
    name: "ProductList",
    components: { ProductAddToCart },
    data() {
      return {
        products: [],
        loading: false,
        cartList: [],
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.loading = true;
        // 获取用户类型
        this.$http.get("basic", "materials/getPageList", { sellType: 20 }).then(res => {
          this.products = res.records.map(item => ({
            ...item,
            loading: false,
          }));
        }).finally(() => {
          this.loading = false;
        });
      },
     
      // 打开产品属性弹窗
      addToCart(product) {
        product.loading = true;
        this.$refs.productAddToCart.openByProductId(product).finally(() => {
          product.loading = false;
        });
      },
     
    },
  };
</script>

<style lang="scss" scoped>
.cart-list {
  padding: 20px;

  h2 {
    margin-bottom: 30px;
    font-size: 24px;
    color: #333;
  }

  .product-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;

    .product-item {
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      padding: 15px;
      transition: all 0.3s;

      &:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }

      .product-image {
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        background-color: #f5f7fa;
        border: 1px dashed #d9d9d9;
        border-radius: 4px;
        flex-direction: column;

        &::after {
          content: '上传中...';
          color: #909399;
          font-size: 14px;
          display: block;
          margin-top: 10px;
        }

        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: cover;
        }
      }

      .product-info {
        text-align: center;
        position: relative;

        .product-name {
          font-size: 14px;
          margin-bottom: 10px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
          position: relative;
          cursor: default;
        }

        .product-price {
          margin-bottom: 15px;

          .price-value {
            font-weight: bold;
            color: #f56c6c;
            margin-left: 10px;
          }
        }

        .el-button {
          width: 120px;
        }
      }
    }
  }
}
</style>
